import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useFormikContext } from 'formik'

import {
  getMergeWarning,
  parseMergeWarningData,
} from 'components/merge-warning/utils'
import { ResponseMeta } from 'lib/types'
import { useContactContext } from 'routes/contact/context'
import { hideModal } from 'state/actions'

import { MergeWarningBase } from './merge-warning-base'

export const MergeWarningForContactPage = ({
  apiMessages,
}: {
  apiMessages: ResponseMeta['messages']
}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { contact, updateContact } = useContactContext()
  const { setFieldValue } = useFormikContext()

  const mergeWarning = getMergeWarning(apiMessages)

  useEffect(() => {
    if (mergeWarning) {
      setFieldValue('email', '')
    }
  }, [setFieldValue, mergeWarning])

  if (!mergeWarning) return <></>

  const mergeWarningData = parseMergeWarningData(mergeWarning)
  const email = mergeWarningData?.email ?? ''
  const thisContactName =
    `${contact.attributes.firstName} ${contact.attributes.lastName}`.trim()

  return (
    <MergeWarningBase
      mergeWarningData={mergeWarningData}
      thisContactName={thisContactName}
      mergeContact={async () => {
        const response = await updateContact({ email, allowMergeContact: true })
        const updatedContact = response?.data

        if (updatedContact && updatedContact.id !== contact.id) {
          history.push(`/contacts/${updatedContact.id}/edit`)
          history.go(0)
        } else {
          setFieldValue('email', email)
        }

        dispatch(hideModal())
      }}
    />
  )
}
